<template>
  <div class="upload-container">
    <div v-for="(item, index) in fileList" :key="index" class="image-item">
      <img :src="item.url" alt="" />
      <span class="delete-box"
        ><i class="el-icon-delete" @click="deleteImage(index)"
      /></span>
    </div>
    <el-upload
      v-show="limit > fileList.length"
      :style="`max-width:${uploadWidth}px;`"
      class="upload-btn"
      :class="{ 'tips-position__right': tipsPosition === 'right' }"
      :limit="limit"
      action="#"
      :auto-upload="false"
      list-type="picture-card"
      :on-change="changeImage"
      :show-file-list="false"
      :file-list="fileList"
      :accept="accept"
    >
      <i class="el-icon-plus" />
      <div slot="tip" class="el-upload__tip form-item__tips" v-html="tips" />
    </el-upload>
  </div>
</template>

<script>
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import { request } from "@saas/service-api/src/request.js";
export default {
  props: {
    // 获取sts的api
    stsApi: {
      type: String,
      default: "",
    },
    // 获取sts的参数
    stsParams: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Array],
      default: () => [],
    },
    // 限制数量
    limit: {
      type: Number,
      default: 1,
    },
    // 限制大小 单位MB
    limitSize: {
      type: Number,
      default: 10,
    },
    // 限制图片类型
    limitType: {
      type: Array,
      default: () => ["jpg", "jpeg", "png"],
    },
    tips: {
      type: String,
      default: "",
    },
    // 上传按钮和tips的最大宽度
    uploadWidth: {
      type: Number,
      default: 300,
    },
    // 提示位置,底部或右边
    tipsPosition: {
      type: String,
      default: "bottom",
    },
    // 绑定值的类型 string: ['xxxxxx', 'xxxxx'], object: [{name: 'xxxx', url: 'xxxx'}]
    dataType: {
      type: String,
      default: "string",
    },
  },
  data() {
    return {
      cos: null,
      fileList: [],
      stsToken: null,
      sts: {},
    };
  },
  computed: {
    accept() {
      return this.limitType.reduce((pre, cur) => {
        return pre + "." + cur + ",";
      }, "");
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          if (
            this.limit === 1 &&
            this.dataType === "string" &&
            typeof val === "string"
          ) {
            this.fileList = [{ url: val }];
          } else if (
            this.limit > 1 &&
            this.dataType === "string" &&
            Array.isArray(val)
          ) {
            this.fileList = val.map((item) => {
              return { url: item };
            });
          } else if (
            this.limit === 1 &&
            this.dataType === "object" &&
            Object.prototype.toString.call(val) === "[object Object]"
          ) {
            this.fileList = [val];
          } else {
            this.fileList = val;
          }
        } else {
          this.fileList = [];
        }
        console.log(this.fileList);
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    checkFormat(file) {
      const fileType = file?.raw?.type?.split("/")?.[1] || "";
      return this.limitType.includes(fileType);
    },
    checkSize(file) {
      return file.size / 1024 / 1024 <= this.limitSize;
    },
    emitInput() {
      if (this.dataType === "string") {
        const list = this.fileList.map((item) => {
          return item.url;
        });
        if (+this.limit === 1) {
          this.$emit("input", list[0]);
        } else {
          this.$emit("input", list.slice(0, +this.limit));
        }
      } else {
        this.$emit("input", this.fileList.slice(0, +this.limit));
      }
      if (this.$parent?.elForm) {
        this.$parent.$emit("el.form.change");
      }
    },
    changeImage(file) {
      if (!this.checkFormat(file)) {
        const formatList = this.limitType.join("、");
        this.$message.error(`请上传 ${formatList} 格式图片!`);
        return false;
      }
      if (!this.checkSize(file)) {
        this.$message.error(`上传图片大小不能超过${this.limitSize}M!`);
        return false;
      }
      this.getStsData(file);
    },
    getStsData(file) {
      request(this.stsApi, "get", {
        params: {
          ...this.stsParams,
          filename: file.name,
        },
      }).then((res) => {
        if (res.code === 1) {
          cosUploadFile(
            {
              file: file.raw,
              fileName: file.name,
            },
            { ...res.data },
            {
              onTaskReady: (taskId) => {
                console.log("taskId>>>>", taskId);
              },
              onProgress: (progerssData) => {
                console.log("progerssData>>>>", progerssData);
              },
              onFileFinish: (err, data, options) => {
                if (data && data.statusCode === 200) {
                  const url = data.Location.startsWith("https://")
                    ? data.Location
                    : "https://" + data.Location;
                  this.fileList.push({
                    url: url,
                    name: file.name,
                  });
                  this.emitInput();
                } else {
                  console.log(err);
                }
              },
            }
          );
        }
      });
    },
    deleteImage(index) {
      this.fileList.splice(index, 1);
      this.emitInput();
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  .upload-btn ::v-deep {
    .el-upload {
      width: 148px;
      height: 148px;
    }

    .el-upload__tip {
      line-height: 24px;
    }
  }

  .tips-position__right {
    display: flex;

    ::v-deep .el-upload {
      width: 148px;
      height: 148px;
    }

    .el-upload__tip {
      flex: 1;
      margin-left: 10px;
      line-height: 24px;
    }
  }
}

.image-item {
  position: relative;
  width: 148px;
  height: 148px;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
  object-fit: contain;

  img {
    width: 100%;
    height: 100%;
  }

  .delete-box {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      cursor: pointer;
      left: 50%;
    }

    &:hover {
      opacity: 1;
    }
  }
}
</style>
